<template>
    <USlideover :model-value="open" @update:model-value="$emit('update:open', $event)">
        <UForm ref="form" @submit="onSubmit" :schema="schema" :state="state" :validate-on="['submit']" class="h-full">
            <UCard>
                <template #header>
                    <div class="flex items-center justify-between">
                        <h3 class="text-base font-medium leading-6 text-gray-800">
                            Add Distributor
                        </h3>
                    </div>
                </template>
                <div class="space-y-6">
                    <UFormGroup name="name" label="Name" required help="Members activated by this distributor receive their welcome message under this name.">
                        <UInput v-model="state.name" type="text" size="xl" />
                    </UFormGroup>
                </div>
                <template #footer>
                    <div class="flex items-center justify-end space-x-2">
                        <UButton @click="dismiss()" size="lg" color="white">
                            Cancel
                        </UButton>
                        <UButton type="submit" size="lg" :loading="loading" color="black">
                            Save
                        </UButton>
                    </div>
                </template>
            </UCard>
        </UForm>
    </USlideover>
</template>

<script setup lang="ts">
import { z } from 'zod'
import type { FormSubmitEvent } from '#ui/types'

const emit = defineEmits<{
    'update:open': [boolean]
    'reload': [boolean]
}>()

const props = defineProps<{
    open: boolean
}>()

const toast = useToast()
const loading = ref<boolean>(false)
const state = ref<{ name?: string }>({})

const schema = z.object({
    name: z.string().trim().min(2, 'Enter at least 2 characters'),
})

watch(() => props.open, (open) => {
    if (open) {
        state.value = {}
    }
})

async function onSubmit(event: FormSubmitEvent<z.infer<typeof schema>>) {
    loading.value = true

    try {
        await $fetch('/api/partner/distributors', { method: 'POST', body: event.data })
        dismiss(true)
    } catch (error: any) {
        toast.add({ title: 'Could not create distributor', description: error.data?.message, color: 'red' })
    }

    loading.value = false
}

function dismiss(reload: boolean = false) {
    emit('update:open', false)
    if (reload) {
        emit('reload', true)
    }
}
</script>
